<form name="ssoLoginForm">
	<bb-line-text>{{ 'OR' | translate | uppercase }}</bb-line-text>

	<div *ngFor="let ssoProvider of ssoProviders" (click)="ssoLogin(ssoProvider.endpoint)"
		class="{{ ssoProvider.type	|| 'generic' }}-sign-in sign-in">
		<div *ngIf="ssoProvider.type && ssoProvider.type !== 'generic'" class="icon"></div>
		<i *ngIf="!ssoProvider.type || ssoProvider.type === 'generic'" class="far fa-arrow-right-to-bracket"></i>
		<div>{{ 'SIGN_IN_WITH' | translate }}&nbsp;{{ ssoProvider.name }}</div>
	</div>
</form>
